import { Link, useParams } from 'react-router-dom';
import avatar from "../../../adminassets/img/avatars/1.png";
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { fetchUsers, setPageLoading } from '../../../service/slice/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import makeAnimated from 'react-select/animated';
import { selectMode } from '../../../service/slice/ThemeSlice';
import Lottie from "lottie-react";
import crown from "../../../studentassets/Lottie/Crown.json";
import Free from "../../../studentassets/Lottie/Free.json";
import norecord from "../../../screenassets/lottiefiles/No-Data.json";
import Loading from '../../Loading';
import { encode, decode } from 'js-base64';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import NoData from '../../NoData';


export default function CustomerDetails() {

    DataTable.use(DT);
    const [userID, setUserId] = useState();
    const [first_name, setFirstName] = useState();
    const [last_name, setLastName] = useState();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [subscriptionHistory, setSubscriptionHistory] = useState([]);
    const [status, setStatus] = useState();
    const [loading, setLoading] = useState(true);
    const [userSubscription, setUserSubscrtiption] = useState();

    const dispatch = useDispatch();
    const authAdminToken = localStorage.getItem("authAdminToken");
    const animatedComponents = makeAnimated();
    const theme = useSelector(selectMode);
    const { id } = useParams();
    const decode_id = decode(id);

    const themeColor = {
        color: theme === 'light' ? '#212529' : '#fff',
        background: theme === 'light' ? '#fff' : '#1c1c39',
        boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)'
    };

    // View Subscription Details Section
    const fetchAllUser = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/userDetails`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${authAdminToken}`
            },
            body: JSON.stringify({ id: decode_id })
        });

        return response.json();
    };

    // View Subscription Details Section
    const fetchAllSubscription = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getUserSubscriptionHistory`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${authAdminToken}`
            },
            body: JSON.stringify({ id: decode_id })
        });

        return response.json();
    };

    // View Subscription Details Section
    const fetchUserSubscription = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getUserSubscription`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${authAdminToken}`
            },
            body: JSON.stringify({ id: decode_id })
        });

        return response.json();
    };

    useEffect(() => {
        fetchAllUser().then((res) => {
            if (res.status) {
                setStatus(res?.userDetails?.status);
                setPhone(res?.userDetails?.phone);
                setEmail(res?.userDetails?.email);
                setFirstName(res?.userDetails?.first_name);
                setLastName(res?.userDetails?.last_name);
                setUserId(res?.userDetails?.id);
            } else {
                toast.error("Unable to load user details. Please try again later.");
            }
            fetchAllSubscription().then((res) => {
                if (res.status) {
                    setSubscriptionHistory(res.subscriptionHistory);
                } else {
                    toast.error("Unable to load subscription. Please try again later.");
                }

                fetchUserSubscription().then((res) => {
                    setUserSubscrtiption(res.subscription);
                    setLoading(false);
                }).catch((error) => {
                    toast.error("Unable to load subscription. Please try again later.");
                })

            }).catch((error) => {
                toast.error("Failed to fetch subscription. Please check your connection and try again.");
            });
        }).catch((error) => {
            toast.error("Failed to fetch subscription. Please check your connection and try again.");
        });

    }, []);

    return (
        <>
            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row">

                        {/* Customer-detail Sidebar */}
                        <div className="col-md-6 order-1 order-md-0">
                            {/* Customer-detail Card */}
                            <div className="card mb-6" style={themeColor}>
                                <div className="card-body pt-12">

                                    <div className="customer-avatar-section">
                                        <div className="d-flex align-items-center flex-column">
                                            <img className="img-fluid rounded-3 mb-4" src={avatar} height="120" width="120" alt="User avatar" />
                                            <div className="customer-info text-center mb-6">
                                                <h5 className="mb-0">{first_name + ' ' + last_name}</h5>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="info-container">
                                        <h5 className="border-bottom text-capitalize pb-4 mt-6 mb-4">Details</h5>
                                        <ul className="list-unstyled mb-6">
                                            <li className="mb-2">
                                                <span className="h6 me-1">Name:</span>
                                                <span>{first_name + ' ' + last_name}</span>
                                            </li>
                                            <li className="mb-2">
                                                <span className="h6 me-1">Email:</span>
                                                <span>{email ? email : 'N/A'}</span>
                                            </li>
                                            <li className="mb-2">
                                                <span className="h6 me-1">Contact:</span>
                                                {phone ? <span>+91 {phone}</span> : <span>N/A</span>}
                                            </li>
                                            <li className="mb-2">
                                                <span className="h6 me-1">Status:</span>
                                                {status ? <span className="badge bg-label-success rounded-pill">Active</span> : <span className="badge bg-label-danger rounded-pill">Inactive</span>}
                                            </li>
                                        </ul>

                                    </div>

                                </div>
                            </div>

                        </div>


                        {/* Customer Content */}
                        <div className="col-md-6">

                            {/* Customer cards */}
                            <div className="row text-nowrap">

                                <div className="mb-6">
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <div className="card-icon mb-2">
                                                <div className="avatar d-none">
                                                    <div className="avatar-initial rounded bg-label-primary">
                                                        <i className="icon-base ri ri-money-dollar-circle-line icon-24px"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="container">
                                                {subscriptionHistory ?
                                                    <div className='me-4'>
                                                        <Lottie animationData={crown} style={{ height: 200 }} />
                                                    </div>
                                                    :
                                                    <div className='d-flex justify-content-center align-items-center me-1'>
                                                        <Lottie animationData={Free} style={{ width: "100px" }} />
                                                    </div>
                                                }

                                                <div className="text-center h3" style={{ color: "#0cce1cff" }}>
                                                    {userSubscription ? userSubscription.name : "Free"}
                                                </div>

                                                <div className="d-flex align-items-center justify-content-center">
                                                    <h4 className="mb-0 me-1">{userSubscription ? userSubscription.amount : "10"}</h4>
                                                    <span>/ {userSubscription?.type === 2 ? "Yearly" : "Monthly"}</span>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="mb-6">
                                <div className="card" style={themeColor}>
                                    <div className="card-body">
                                        <div className="card-info">
                                            <h5 className="card-title mb-2">Total Request</h5>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="d-flex align-items-center mt-0 ms-2">
                                                <h4 className="mb-0 me-1 text-primary">
                                                    {userSubscription ? userSubscription.total_request : 0}
                                                </h4>
                                            </div>

                                            <span className='ms-1'>Question Left  Out of  {userSubscription ? userSubscription.request : 0}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex gap-2'>
                                <Link to={`/admin/searchHistory/${encode(userID)}`} className='btn btn-primary w-50'>Go to search history</Link>
                                {status ? <button className='btn btn-danger w-50'>Deactivate User</button> : <button className='btn btn-outline-success w-50'>Activate User</button>}
                            </div>
                        </div>


                        <div className="container-xxl flex-grow-1 container-p-y my-5 px-3" style={{ height: "62vh" }}>
                            <div className="card shadow-sm border-0">
                                <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0">
                                    <h5 className="card-title mb-0">User Subscription History</h5>
                                </div>

                                {subscriptionHistory.length > 0 ?

                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <DataTable data={subscriptionHistory.map((pack, index) => {

                                                return [
                                                    index + 1,
                                                    pack.name,
                                                    pack.amount,
                                                    pack.type == "2" ? "Yearly" : "Monthly",
                                                    pack.status ? '<div class="text-success">Active</div>' : '<div class="text-danger">Inactive</div>'
                                                ];
                                            })}

                                                className="display">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Name</th>
                                                        <th>Amount</th>
                                                        <th>Type</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                            </DataTable>
                                        </div>
                                    </div>
                                    :
                                    <NoData />
                                }

                            </div>
                        </div>


                    </div>
                </div>}


        </>
    )
}
